import { OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Component } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Validators } from '@angular/forms';
import { FormControl } from '@angular/forms';
import { ValidatorFn } from '@angular/forms';
import { AbstractControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { User } from 'src/app/model/settings/user.model';
import { UserService } from 'src/app/service/user.service';
import { AlertService } from 'src/app/service/alert.service';
import { AnalyticsService } from 'src/app/service/analytics/analytics.service';

@Component({
  selector: 'app-invite-acceptance',
  templateUrl: './invite-acceptance.component.html',
  styleUrls: ['./invite-acceptance.component.scss']
})
export class InviteAcceptanceComponent implements OnInit {

  public inviteForm!: FormGroup<{ [key: string]: AbstractControl }>;
  public currentYr = new Date().getFullYear();

  constructor(private userService: UserService,
              private alertService: AlertService,
              private analytics: AnalyticsService,
              private router: Router,
              private activeRoute: ActivatedRoute) { }

  ngOnInit(): void {

    this.inviteForm = new FormGroup<{ [key: string]: AbstractControl }>({
      first: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
      last: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
      email: new FormControl({value : '', disabled: true}, { nonNullable: true, validators: [Validators.required,
                                                            Validators.email] }),
      phone: new FormControl('', { nonNullable: true, validators: [Validators.required,
                                  Validators.minLength(10)] }),
      password: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
      confirmedPassword: new FormControl('', { nonNullable: true, validators: [Validators.required,
                                              this.confirmEquals()] })
    });

    this.activeRoute
        .queryParams
        .subscribe(params => {

      if (params['email']) {
        this.inviteForm.get('email')?.setValue(params['email']);
      }
    });
  }

  private confirmEquals(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null =>
        control.value?.toLowerCase() === this.passwordValue().toLowerCase()
            ? null : {noMatch: true};
  }

  private passwordValue(): string {
    let value = '';

    if (this.inviteForm) {
      value = this.inviteForm.get('password')?.value;
    }

    return value;
  }

  private mapFormToModel(): User {
    let user: any = new User();

    for(let control in this.inviteForm.controls) {
      if (control !== 'confirmedPassword') {
        user[control] = this.inviteForm.controls[control].value;
      }
    }

    return user;
  }

  public getFormControl(form: FormGroup, formControl: string): AbstractControl {
    let fControl: any;

    fControl = form.get(formControl)

    return fControl;
  }

  public onRegister(): void {

    this.activeRoute
        .queryParams
        .subscribe(params => {
          this.userService
              .accept(params['token'],
                      this.mapFormToModel())
              .subscribe(()=>{

                this.analytics.track('Invite Accepted');
                this.alertService
                    .success('Registred Succesfully');
                this.router.navigate(['login']);
        }, err => {
              console.error(err);
              this.alertService
                  .error(err.message, err);
            }
          );
        })
  }
}
